import { createMarketplaceEventFactory } from '../../';
import { SearchResultEventProps } from './types';

export const getSearchResultClickedEvent =
  createMarketplaceEventFactory<SearchResultEventProps>(
    'Marketplace',
    'Search Result Clicked'
  );

export const getSearchResultViewedEvent =
  createMarketplaceEventFactory<SearchResultEventProps>(
    'Marketplace',
    'Search Result Viewed'
  );
